export enum TipoGuardadoInstitucion {
  POSICION_ACTUAL = '1',

  POSICION_ACTUAL_Y_NIVELES = '2',
}
